import React from 'react';
import { StyleSheet, View } from 'react-native';
import {
	AuthTemplate,
	ForgotPasswordForm,
	LoginFooter,
	TermsAndConditions,
} from '../components';
import LoginHeroImage from '../components/auth/LoginHeroImage';
import { useIsSpecificViewportWidth } from '../hooks/useIsSpecificViewportWidth';
import { TStyle } from '../types/TStyle';
import { getResponsiveStyle } from '../utils/getResponsiveStyle';

const ForgotPassword = () => {
	const { isDesktop } = useIsSpecificViewportWidth();
	return (
		<View style={isDesktop && styles.container}>
			<LoginHeroImage />
			<AuthTemplate
				heading={'Forgot Password?' }
				subText={'Enter your email address to get reset link.'}
				contentStyles={styleMainContent(isDesktop)}
				authType={'login'}
				scrollItems={[]}
				
			>
				<ForgotPasswordForm />
				{isDesktop && <LoginFooter />}
				{isDesktop && <TermsAndConditions />}
			</AuthTemplate>
		</View>
	);
};

const styles = StyleSheet.create({
	container: {
		flexDirection: 'row',
		minWidth: '100vw',
		height: '100vh',
	},
});

function styleMainContent(isDesktop: boolean): TStyle {
	return {
		marginTop: getResponsiveStyle(isDesktop ? 0 : 40),
	};
}

export default ForgotPassword;
